import classNames from "classnames";
import { useState } from "react";
import { ACORIS_PROFILES } from "utils/constants";
import agentTerritorialIcon from "../Assets/images/profile-agent-territorial.svg";
import entrepriseIcon from "../Assets/images/profile-entreprise.svg";
import frontalierIcon from "../Assets/images/profile-frontalier.svg";
import independantIcon from "../Assets/images/profile-independant.svg";
import particulierIcon from "../Assets/images/profile-particulier.svg";
import Button from "../Components/Button";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import Rgpd from "../Components/Rgpd";

const PROFILE_OPTION_CONFIG = {
  [ACORIS_PROFILES.PARTICULAR]: {
    icon: particulierIcon,
    iconClassName: "acoris-profile__card-icon--particulier",
  },
  [ACORIS_PROFILES.TNS]: {
    icon: independantIcon,
    iconClassName: "acoris-profile__card-icon--independant",
  },
  [ACORIS_PROFILES.TERRITORIAL_AGENT]: {
    icon: agentTerritorialIcon,
    iconClassName: "acoris-profile__card-icon--agent",
  },
  [ACORIS_PROFILES.BUSINESS_LEADER]: {
    icon: entrepriseIcon,
    iconClassName: "acoris-profile__card-icon--entreprise",
  },
  [ACORIS_PROFILES.CROSS_BORDER_WORKER]: {
    icon: frontalierIcon,
    iconClassName: "acoris-profile__card-icon--frontalier",
  },
};

const PROFILE_OPTIONS = Object.values(ACORIS_PROFILES).map((id) => ({
  id,
  ...PROFILE_OPTION_CONFIG[id],
}));

function View({ translate, onNext, initialValue }) {
  const [selected, setSelected] = useState(initialValue || null);

  return (
    <Layout>
      <Header
        subtitle={translate?.HEADER?.SUBTITLE || "Votre situation"}
        title={translate?.HEADER?.TITLE || "Quel est votre profil ?"}
        highlight={translate?.HEADER?.HIGHLIGHT || "profil"}
      />

      <div className="acoris-profile__cards">
        {PROFILE_OPTIONS.map(({ id, icon, iconClassName }) => (
          <button
            key={id}
            type="button"
            className={classNames("acoris-profile__card", {
              "acoris-profile__card--active": selected === id,
            })}
            onClick={() => setSelected(id)}
          >
            <span
              className={classNames("acoris-profile__card-icon", iconClassName)}
            >
              <img src={icon} alt="" />
            </span>
            <span className="acoris-profile__card-label">
              {translate?.OPTIONS?.[id]}
            </span>
          </button>
        ))}
      </div>

      <div className="acoris-profile__cta">
        <Button
          type="primary"
          disabled={!selected}
          onClick={() => onNext(selected)}
        >
          {translate?.BUTTON?.START || "C'est parti !"}
        </Button>
      </div>

      <Rgpd />
    </Layout>
  );
}

export default View;
